import UseCase from "../../core/useCase/UseCase";
import { SessionRepository } from "../repository/SessionRepository";

export class SetSessionEndedReasonParams {
  reason: string;

  constructor(reason: string) {
    this.reason = reason;
  }
}

/** Records why the session ended so /login can explain it to the member. */
export default class SetSessionEndedReason extends UseCase<
  void,
  SetSessionEndedReasonParams
> {
  repository: SessionRepository;

  constructor(repository: SessionRepository) {
    super();
    this.repository = repository;
  }

  execute = (params: SetSessionEndedReasonParams) =>
    this.repository.setEndedReason(params.reason);
}
